import {
  CONTENTFUL_LOCALES_OBJ,
  ContentfulLocale,
  ContentfulLocalesObjType,
  Locale,
  TERRITORIES_OBJ,
  Territory,
} from '@core/constants/locales.constants';
import { reverseObject } from '@utils/objects.utils';
import { contentfulLocales } from '../../../contentful.locales';
import { RTL_LANGS } from './rtlLocales.constants';

export const localeToContentfulLocale = (locale: Locale): ContentfulLocale =>
  CONTENTFUL_LOCALES_OBJ[locale] ??
  (() => {
    throw new Error(`Invalid locale: ${locale}`);
  })();

export const contentfulLocaleToLocale = (
  contentfulLocale: ContentfulLocale
): Locale =>
  reverseObject<ContentfulLocalesObjType>(CONTENTFUL_LOCALES_OBJ)[
    contentfulLocale
  ] ??
  (() => {
    throw new Error(`Invalid contentfulLocale: ${contentfulLocale}`);
  })();

export const getLocalisedKeyName = (keyStart: string, locale: Locale) =>
  `${keyStart}${locale.replace(/-/g, '')}${TERRITORIES_OBJ[locale]}`;

export const localeToTerritory = (locale: Locale): Territory =>
  TERRITORIES_OBJ[locale] ??
  (() => {
    throw new Error(`Invalid locale: ${locale}`);
  })();

export const isRtlLocale = (routerLocale: string): boolean => {
  // Find the matching locale config
  const localeConfig = contentfulLocales.find(
    (loc) => loc.router === routerLocale
  );
  if (!localeConfig) return false;
  // Check if the language code is in the RTL list
  return RTL_LANGS.includes(localeConfig.router);
};
